<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="book"><a id="page_xvii">H<span class="smallcaps">OW TO</span> U<span class="smallcaps">SE</span> T<span class="smallcaps">HIS</span> B<span class="smallcaps">OOK</span><br/><span class="smallcaps"><em>… from the Inside Out</em></span></a></h2><a id="page_xvii">
<p class="noindent"><em>Leadership from the Inside Out</em> guides you through a reflective journey to grow as a whole person in order to grow as a whole leader. We will not simply analyze the external act of leadership, breaking it down into a simplistic formula of “ten easy-to-follow tips.” Instead, you will experience and embody the learning, growth, and transformation to become a leader for life.</p>
<p class="noindentt">You need not rush. As a matter of fact, I encourage you to set aside the urge to plow through the pages. Instead, when a thought or feeling surfaces, pause. Close the book, put up your feet, and explore the insight. If you have a breakthrough, take the time to capture it by writing it down. Instead of just reading the book, experience it, digest it, and integrate it into your life.</p>
<p class="noindentt">You’ve probably read all sorts of personal and professional development books; treat this one differently. Savor it as you would a walk with an old friend on a calm, sunny afternoon. There is no need to hurry, to anticipate, or to reach the end of your journey. On the contrary, your true reward is in pausing frequently and immersing yourself in the experience itself.</p>
<p class="noindentt">On days you feel like taking a short walk, just skim the quotes. You’ll find one or two that speak to your needs that day.</p>
</a><p class="noindentt"><a id="page_xvii">If you are ready to begin, let’s take a walk together down the eight pathways to mastery of <em>Leadership from the Inside Out</em>.</a><a id="page_xviii"></a></p><a id="page_xviii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// book.vue?a288c6f4